import { useRef, useState } from "react";
import { useDataContext } from "../../Context/DataContext";
import _gsap from "gsap/gsap-core";
import { useGSAP } from "@gsap/react";
import { Link } from "react-router-dom";

export const Internship = () => {
    const { internship } = useDataContext();

    const [noOfElement, setNoOfElement] = useState(1);
    const totalInternships = internship.length;
    // eslint-disable-next-line
    const loadMore = () => {
        setNoOfElement((prev) => Math.min(prev + 1, totalInternships));
    };

    // const slice = internship.slice(0, noOfElement); // first index
    const slice = internship.slice(-noOfElement); // Last Index

    // --- GSAP Animation Refs ---
    const sectionRef = useRef(null);
    const titleRef = useRef(null);
    const buttonRef = useRef(null);

    useGSAP(() => {
        // Create a timeline that triggers when the section scrolls into view
        const internshipTl = _gsap.timeline({
            scrollTrigger: {
                trigger: sectionRef.current,
                start: 'top 80%',
                toggleActions: 'play none none reverse',
            },
            defaults: { ease: 'power3.out', duration: 1 }
        });

        // 1. Animate the "Internship" title
        internshipTl.from(titleRef.current, {
            y: 50,
            opacity: 0,
        });

        // 2. Animate the image from the left
        internshipTl.from('.internship-image', {
            x: 100,
            opacity: 0,
        }, "-=0.7"); // Overlap with previous animation

        // 3. Animate the text details from the right
        internshipTl.from('.internship-details', {
            x: 100,
            opacity: 0,
        }, "<"); // Start at the same time as the image animation

        // 4. Animate the "More Internships" button
        internshipTl.from(buttonRef.current, {
            y: 20,
            opacity: 0,
            duration: 0.5,
        }, "-=0.5"); // Overlap slightly

    }, { scope: sectionRef });

    return (
        <>
            <div ref={sectionRef} className='md:px-20 xl:px-32 text-center text-surface lg:text-left'>
                <div className='container mx-auto pt-14 sm:pt-20 md:pt-28 pb-5 px-9'>
                    {/* Internship */}
                    <p ref={titleRef} className='font-pockota font-bold text-2xl sm:text-3xl md:text-4xl text-y-col'>Experience</p>
                    {slice.map((internship, index) => (
                        <div className="flex flex-col lg:flex-row items-center pt-10 lg:py-10 gap-5 lg:gap-10 dark:text-tx-col" key={index}>
                            <div className={`internship-image lg:w-1/2 w-full overflow-hidden rounded-lg ${internship.class || null}`}>
                                <img className='w-full h-full' src={internship.img} alt={`${internship.alt}'s Landing Page`} />
                            </div>
                            <div className='internship-details lg:w-1/2 flex flex-col items-start gap-6'>
                                <img className={`${internship.height || 'h-16'}`} src={internship.logo} alt={internship.alt} title={internship.alt} />
                                <h3 className='text-sm sm:text-base lg:text-lg font-medium'>{internship.duration}</h3>
                                <p className='text-sm sm:text-base lg:text-lg font-light text-justify'>{internship.p1}</p>
                                <p className='text-sm sm:text-base lg:text-lg font-light text-justify'>{internship.p2}</p>
                            </div>
                        </div>
                    ))}
                    <div className='flex flex-col justify-center'>
                        <Link aria-label="Watch More Experience" ref={buttonRef} to='/internships' className='backdrop-blur-lg bg-[#00000040] text-blue-500 border border-y-col rounded-full mt-5 px-4 py-1 w-fit mx-auto'>More Interships</Link>
                        {/* {noOfElement < totalInternships && (
                            <>
                                <button
                                    className='backdrop-blur-lg bg-[#00000040] text-blue-500 border border-y-col rounded-full mt-5 px-4 py-1 w-fit mx-auto'
                                    onClick={loadMore}
                                >
                                    Load More
                                </button>
                            </>
                        )} */}
                    </div>
                </div>
            </div>
        </>
    )
}